import { render, staticRenderFns } from "./sign_award_log.vue?vue&type=template&id=5520da47&scoped=true"
import script from "./sign_award_log.vue?vue&type=script&lang=ts"
export * from "./sign_award_log.vue?vue&type=script&lang=ts"
import style0 from "./sign_award_log.vue?vue&type=style&index=0&id=5520da47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5520da47",
  null
  
)

export default component.exports